var map = {
	"./MJU.svg": 1137,
	"./MOL.svg": 3570,
	"./RMS.svg": 2303,
	"./SKB.svg": 4517,
	"./abm.svg": 8899,
	"./delta-team.svg": 6249,
	"./generali.svg": 6482,
	"./ikona.svg": 3114,
	"./kad.svg": 8233,
	"./monetic.svg": 9498,
	"./nlb.svg": 1568,
	"./trigal.svg": 1298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1625;